// extracted by mini-css-extract-plugin
export default {"buttonsRow":"TeamsUpgradeButtons_buttonsRow__e+bak"};